import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import BookShowcase from '../components/BookShowcase';
import SpeakerSocialLinks from '../components/SpeakerSocialLinks';
import { SPONSOR_FORM_URL } from '../config';
import '../styles/DavidSinclairPage.css';

function MatthewWalkerPage() {
  return (
    <>
      <Navbar />
      
      {/* Hero Section */}
      <section className="speaker-hero">
        <video 
          className="speaker-hero-video"
          autoPlay 
          muted 
          loop 
          playsInline
        >
          <source src="/assets/video-hero.webm" type="video/webm" />
        </video>
        <div className="speaker-hero-overlay"></div>
        
        <div className="container">
          <div className="speaker-hero-content">
            <div className="speaker-hero-left">
              <h1 className="speaker-hero-name">
                MATTHEW<br />WALKER
              </h1>
              <SpeakerSocialLinks speakerId="matthew-walker" className="speaker-hero-socials" linkClassName="speaker-hero-social-icon" />
              <Link to="https://my.brain-event.com" className="btn btn-primary btn-large btn-pulse speaker-hero-btn">
                CUMPĂRĂ UN TICKET
              </Link>
            </div>
            
            <div className="speaker-hero-right">
              <img 
                src="/assets/matthew-walker-transparent.png" 
                alt="Matthew Walker" 
                className="speaker-hero-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Who is Matthew Walker */}
      <section className="sinclair-intro">
        <div className="container">
          <div className="sinclair-intro-grid">
            <div className="sinclair-intro-content">
              <div className="sinclair-badge">MATTHEW WALKER</div>
              <h2 className="sinclair-intro-title">Cine este Matthew Walker?</h2>
              <p className="sinclair-intro-text">
                Matthew Walker este unul dintre cei mai cunoscuți cercetători din lume în domeniul <strong>somnului</strong>.
              </p>
              <p className="sinclair-intro-text">
                Conduce <strong>Center for Human Sleep Science la UC Berkeley</strong> și este autorul bestsellerului global <strong>„Why We Sleep"</strong>.
              </p>
            </div>
            <div className="sinclair-intro-image">
              <img 
                src="/assets/matthew-walker-speaker.webp" 
                alt="Matthew Walker"
                className="sinclair-portrait"
              />
              {/* Floating Stats Cards */}
              <div className="floating-stats-cards">
                <div className="floating-stat-card">
                  <div className="floating-stat-number">150+</div>
                  <div className="floating-stat-label">Articole științifice</div>
                </div>
                <div className="floating-stat-card">
                  <div className="floating-stat-number">Bestseller</div>
                  <div className="floating-stat-label">Why We Sleep</div>
                </div>
                <div className="floating-stat-card">
                  <div className="floating-stat-number">UC Berkeley</div>
                  <div className="floating-stat-label">Profesor • Director</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Matthew Walker Book Showcase */}
      <BookShowcase
        badge="Bestseller mondial"
        mainTitle="Autorul cărții &quot;Why We Sleep&quot;"
        description="&quot;Why We Sleep&quot; a schimbat felul în care lumea înțelege somnul. La Brain Event, vezi știința somnului explicată clar, pe înțelesul tuturor, cu aplicații reale."
        bookImage="/assets/matthew-walker-why-we-sleep.jpeg"
        primaryButtonText="Rezervă bilet"
        primaryButtonLink="https://my.brain-event.com"
        secondaryButtonText="Vezi pachete"
        secondaryButtonLink="https://my.brain-event.com"
        backgroundColor="#F5F1E8"
      />

      {/* What He Will Talk About */}
      <section className="benefits" id="despre-ce-va-vorbi">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Despre ce va vorbi</h2>
            <p className="section-subtitle">Teme centrale din prezentarea lui Matthew Walker</p>
          </div>

          <div className="benefits-stories-grid">
            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/de-ce-somnul-este-fundamentul-sanatatii.png)'}}>
              <div className="story-badge">Fundament</div>
              <div className="story-content">
                <h3 className="story-title">De ce somnul este fundamentul sănătății</h3>
                <p className="story-description">Cum afectează somnul toate sistemele corpului și de ce este esențial</p>
              </div>
            </div>

            <div className="benefit-story-card benefit-story-featured" style={{backgroundImage: 'url(/assets/cum-lipsa-somnului-afecteaza-memoria.png)'}}>
              <div className="story-badge story-badge-featured">Impact</div>
              <div className="story-content">
                <h3 className="story-title">Cum lipsa somnului afectează memoria, emoțiile și performanța</h3>
                <p className="story-description">Consecințele concrete ale privării de somn asupra minții și corpului</p>
              </div>
            </div>

            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/cum-arata-un-program-de-somn-mai-profund.png)'}}>
              <div className="story-badge">Program</div>
              <div className="story-content">
                <h3 className="story-title">Cum arată un program de somn corect și realist</h3>
                <p className="story-description">Structura unui program de somn care funcționează în viața reală</p>
              </div>
            </div>

            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/tehnicii-simple-pentru-un-somn-mai-profund.png)'}}>
              <div className="story-badge">Tehnici</div>
              <div className="story-content">
                <h3 className="story-title">Tehnici simple pentru un somn mai profund</h3>
                <p className="story-description">Metode practice pentru somn mai profund și recuperator</p>
              </div>
            </div>

            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/ce-spune-stiinta-despre-cofeina.png)'}}>
              <div className="story-badge">Știință</div>
              <div className="story-content">
                <h3 className="story-title">Ce spune știința despre cofeină</h3>
                <p className="story-description">Dovezi științifice despre factorii care afectează somnul</p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large">Cumpără un ticket</a>
          </div>
        </div>
      </section>

      {/* How It Helps You */}
      <section className="sinclair-benefits-you">
        <div className="container">
          <div className="section-header-centered">
            <h2 className="section-title">Cu ce te ajută pe tine</h2>
            <p className="section-subtitle">Beneficii concrete din prezentarea lui Matthew Walker</p>
          </div>

          <div className="benefits-you-list">
            <div className="benefit-you-item">
              <div className="benefit-you-number">01</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Somn mai bun, energie mai bună</h3>
                <p className="benefit-you-description">Înțelegi <strong>ce să schimbi ca să te trezești odihnit</strong>, nu doar "în viață"</p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">02</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Minte mai clară</h3>
                <p className="benefit-you-description">Vezi cum somnul îți influențează <strong>focusul, memoria și deciziile</strong></p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">03</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Emoții mai stabile</h3>
                <p className="benefit-you-description">Înțelegi <strong>de ce lipsa somnului amplifică stresul și iritabilitatea</strong></p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">04</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Performanță în viața reală</h3>
                <p className="benefit-you-description">Aplici <strong>principii simple care îți cresc randamentul</strong> la muncă și în sport</p>
              </div>
            </div>

            <div className="benefit-you-item featured">
              <div className="benefit-you-number">05</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Direcție clară</h3>
                <p className="benefit-you-description">Pleci cu un plan: <strong>ce faci azi, ce e mit și ce e știință</strong></p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large btn-pulse">Rezervă-ți locul acum</a>
            <p className="cta-subtitle">Locuri limitate • Brain Event 2026</p>
          </div>
        </div>
      </section>

      {/* What He Has Done */}
      <section className="sinclair-discoveries">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Ce a descoperit</h2>
            <p className="section-subtitle">Contribuții care contează</p>
          </div>

          <div className="discoveries-grid">
            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="24" r="16" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M24 12 L24 24 L32 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <circle cx="24" cy="24" r="2" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="discovery-title">Center for Human Sleep Science</h3>
              <p className="discovery-description">A creat și conduce Center for Human Sleep Science la UC Berkeley</p>
            </div>

            <div className="discovery-card featured">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="12" y="8" width="24" height="32" rx="2" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <line x1="18" y1="16" x2="30" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <line x1="18" y1="22" x2="30" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <line x1="18" y1="28" x2="26" y2="28" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h3 className="discovery-title">150+ lucrări științifice</h3>
              <p className="discovery-description">A publicat 150+ lucrări despre somn, creier și performanță</p>
            </div>

            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 8 L32 20 L28 20 L28 28 L36 28 L36 32 L28 32 L28 40 L20 40 L20 32 L12 32 L12 28 L20 28 L20 20 L16 20 L24 8Z" fill="currentColor" opacity="0.3"/>
                  <circle cx="24" cy="24" r="4" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="discovery-title">Somn în mainstream</h3>
              <p className="discovery-description">A adus somnul în mainstream prin „Why We Sleep"</p>
            </div>

            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="16" r="6" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <circle cx="14" cy="32" r="4" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <circle cx="24" cy="32" r="4" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <circle cx="34" cy="32" r="4" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <line x1="24" y1="22" x2="24" y2="28" stroke="currentColor" strokeWidth="2"/>
                  <line x1="24" y1="28" x2="14" y2="28" stroke="currentColor" strokeWidth="2"/>
                  <line x1="24" y1="28" x2="34" y2="28" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
              <h3 className="discovery-title">Consultant pentru echipe de elită</h3>
              <p className="discovery-description">A fost consultant pentru echipe sportive și organizații mari (NFL/NBA/companii)</p>
            </div>
          </div>
        </div>
      </section>

      {/* Speakers Section */}
      <section className="benefits" id="speakeri">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Alți Speakeri de la Brain Event 2026</h2>
            <p className="section-subtitle">Experți de top din domeniul neuroștiinței și optimizării cognitive</p>
          </div>

          <div className="benefits-stories-grid">
            {/* David Sinclair */}
            <Link to="/david-sinclair" className="benefit-story-card" style={{backgroundImage: 'url(/david-sinclair-headshot-2024.png)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">David Sinclair</h3>
                <p className="story-description">Profesor Harvard • Expert în Longevitate</p>
              </div>
            </Link>

            {/* Diana Palotas */}
            <Link to="/diana-palotas" className="benefit-story-card benefit-story-featured" style={{backgroundImage: 'url(/assets/Diana-Palotas-card.webp)'}}>
              <div className="story-badge story-badge-featured">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Diana Palotas</h3>
                <p className="story-description">CEO Neuros • Specialist în Neurotehnologie</p>
              </div>
            </Link>

            {/* Dr. Daniel Amen */}
            <Link to="/daniel-amen" className="benefit-story-card" style={{backgroundImage: 'url(/assets/amen-speaker.webp)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Dr. Daniel Amen</h3>
                <p className="story-description">Medic în Sănătatea Creierului • Prezență Online</p>
              </div>
            </Link>

            {/* Niculina Gheorghiță */}
            <Link to="/niculina-gheorghita" className="benefit-story-card" style={{backgroundImage: 'url(/assets/niculina-psiholog.webp)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Niculina Gheorghiță</h3>
                <p className="story-description">Psiholog • Autor • Trainer</p>
              </div>
            </Link>

            {/* Specialist Neurofiziologie */}
            <div className="benefit-story-card" style={{backgroundImage: 'url(/mysterious-speaker-new.png)'}}>
              <div className="story-badge">VA FI ANUNȚAT</div>
              <div className="story-content">
                <h3 className="story-title">Specialist Neurofiziologie</h3>
                <p className="story-description">Standardele moderne ale neurofiziologiei</p>
              </div>
            </div>

            {/* Expert Neuromodulare */}
            <div className="benefit-story-card" style={{backgroundImage: 'url(/mysterious-speaker-new.png)'}}>
              <div className="story-badge">VA FI ANUNȚAT</div>
              <div className="story-content">
                <h3 className="story-title">Expert Neuromodulare</h3>
                <p className="story-description">Optimizarea recuperării sistemului nervos</p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large">Cumpara un ticket</a>
          </div>
        </div>
      </section>

      {/* Contact / Sponsor form — now on dedicated sponsorship app */}
      <section className="speaker-contact">
        <div className="container">
          <div className="speaker-contact-header">
            <h2 className="speaker-contact-title">Ai întrebări despre Matthew Walker sau Brain Event?</h2>
            <p className="speaker-contact-subtitle">
              Completează formularul de sponsorizare și echipa noastră te va contacta în cel mai scurt timp.
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <a href={SPONSOR_FORM_URL} className="btn btn-primary btn-large">Aplică pentru Sponsorizare</a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default MatthewWalkerPage;
